import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import getConfig from '../env';
import { getTime } from '../fetch-api/lib/auth-token';

const inMemoryCache = new InMemoryCache();

const getToken = () => {
  const token = fetch(
    `${getConfig('COMMON_UI_JACKET_URL')}/getHttpOnlyCookie?name=cc-admin-sso&nocache=${getTime()}`,
    {
      method: 'GET',
      credentials: 'include'
    },
  )
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      }
      throw new Error(res);
    })
    .then((data) => {
      if (data && data.value) {
        const result = JSON.parse(data.value);
        const { access_token: accessToken = '' } = result;
        return accessToken;
      }
      return '';
    })
    .catch(() => {});
  return token;
};

export const clientFetchWrapper = async (url, opts = {}) => {
  const token = await getToken();
  const AppName = getConfig('APP_NAME');
  const AppVersion = getConfig('APP_VERSION');
  return fetch(url, {
    ...opts,
    headers: {
      ...opts.headers,
      Authorization: `Bearer ${token}`,
      'apollographql-client-name': AppName,
      'apollographql-client-version': AppVersion
    }
  });
};

export const clientGateway = (gatewayApiUrl) =>
  new ApolloClient({
    cache: inMemoryCache,
    link: createHttpLink({ fetch: clientFetchWrapper, uri: gatewayApiUrl })
  });
